type filter = {
  searchText: string;
  status: number;
  searchDate?: string; // ISO date string
};
export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter: filter;
  clinicId: number;
};

// type InPlan = {
//   inPlanId: number;
//   inPlanName: string;
// };
type InGroup = {
  inGroupId: number;
  inGroupName: string;
};

type Insurance = {
  insuranceNameId: number;
  insuranceName: string;
};

type InsuranceType = {
  insTypeId: number;
  insuranceTypeName: string;
};

export type InsurancePlanType = {
  inPlanCreateById: number;
  planId: number | null;
  planCode: string;
  planName: string;
  planStatus: number;
};



export type MasterTableDataType = {
  inGroup: InGroup;
  inPlan: InsurancePlanType[];
  insurance: Insurance;
  insuranceType: InsuranceType;
  clinicId: number;
  inPlanStatus: number;
  inPlanCode: string;
};

export type MasterDataType = {
  // inPlanId: number | null;
  inPlanCode: string;
  inPlanName: InsurancePlanType[];
  inTypeId: number | null;
  inNameId: number | null;
  inGroupId: number | null;
  inPlanStatus: number | null;
  inPlanCreateById: number | null;
  clinicId: number;
};


export type InsuranceDeleteType = {
  // inPlanId: number | null;

  clinicId: number;
   inPlanId: number;
};

// type InPlanNameItem = {
//   inPlanCreateByDate: string; // ISO date string
//   planId: number | null;
//   planName: string;
//   inPlanCreateById: number;
//   planStatus: number;
// };

export type SaveResponseType = {};

export type MasterFormDataType = {
  insType: { id: number; name: string } | null;
  insurance: { id: number; name: string } | null;
  inGroup: { id: number; name: string } | null;
  inPlan: string | null;
  inPlanCode: string;
  status: number;
};

export const initialFormData: MasterFormDataType = {
  insType: null,
  insurance: null,
  inGroup: null,
  inPlan: "",
  inPlanCode: "",
  status: 1,
};
